import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { normalizeRepairReportDetail } from './normalizeRepairReportDetail';

/**
 * SN 最新維修報告（含 repairItem／signReceipt summary）。
 * GET `/aftersales/repair-report/latest?serial_no=`
 * `data.report` 扁平 nested inspection／history。
 *
 * @param {string} serialNo
 */
export async function fetchRepairReportLatestBySerialNo(serialNo) {
  const { data: raw } = await request.get('/aftersales/repair-report/latest', {
    params: { serial_no: serialNo },
  });
  const parsed = parseVer4DetailResponse(raw);
  const data = parsed.data;
  if (!data || typeof data !== 'object') {
    return parsed;
  }
  return {
    ...parsed,
    data: {
      ...data,
      report: normalizeRepairReportDetail(data.report),
    },
  };
}
